import Vue from 'vue/dist/vue.esm'

Vue.component('navigation-index-main-vue', () => import(/* webpackChunkName: "[request]" */ 'components/navigation_index/Main'))
